import { colors } from '@styles/colors';

export const tablaEstylos = {
  width: '100%',
  borderCollapse: 'collapse',
  marginTop: '2vh',
  backgroundColor: colors.white,
  borderRadius: '1vh',
  overflow: 'hidden',
  boxShadow: `0 0.2vh 0.4vh ${colors.tableShadow}`,
  fontSize: '1.6vh',
  fontFamily: 'Inter'
};

export const tablaTheadEstylos = {
  backgroundColor: colors.gray100,
};

export const thStyle = { 
  backgroundColor: colors.gray100, 
  padding: '1.2vh', 
  borderBottom: `0.2vh solid ${colors.gray200}`, 
  textAlign: 'left',
  fontSize: '2vh',
  fontFamily: 'Inter',
  fontWeight: '600'
};

export const tdStyle = {
  padding: '1.2vh',
  borderBottom: `0.1vh solid ${colors.gray200}`
};

export const trStyle = (index) => ({
  backgroundColor: index % 2 === 0 ? colors.white : colors.gray50
});

